import Map from './Map';

const getPointCoords = function (elem) {
  const arrayString = elem.getAttribute('data-coords').split(';');
  const arrayPoints = arrayString.map((str) => {
    return str.split(',');
  });
  return arrayPoints;
};

const toggleContacts = function (id) {
  const newContact = contactsWrap.querySelector(`[data-contact='${id}']`);
  const oldContact = contactsWrap.querySelector('[data-contact].is-show');
  if (oldContact) {
    oldContact.classList.remove('is-show');
  }
  newContact.classList.add('is-show');
};

const domElem = document.querySelector('#map-contact');
const points = domElem && getPointCoords(domElem);
const btnsContact = document.querySelectorAll('.js-btn-contact');
const contactsWrap = document.querySelector('.js-map-contacts');

const mapOptions = {
  center: points ? points[0] : [55.746791, 37.552184],
  zoom: 15,
  behaviors: ['drag'],
  controls: [],
};

const PointLayoutOptions = {
  name: 'PointLayout',
  tmpl:
  `
  <div class="map-point">
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M23 46C31.5 37.6 40 30.0784 40 20.8C40 11.5216 32.3888 4 23 4C13.6112 4 6 11.5216 6 20.8C6 30.0784 14.5 37.6 23 46Z" fill="#FF3900"/>
      <path d="M32.9241 17.3069C32.6228 17.1245 32.2936 17.0248 31.9645 16.9959C31.905 16.9907 31.8469 16.9881 31.7874 16.9868C31.7702 16.9868 31.753 16.9841 31.7358 16.9841C31.7187 16.9841 31.7001 16.9868 31.683 16.9868C31.6631 16.9868 31.6446 16.9881 31.6248 16.9894C30.7445 17.0327 29.9963 17.5759 29.6699 18.3421L27.6515 21.6445L25.4573 18.0547C25.4493 18.0416 25.4388 18.0285 25.4308 18.0154C25.4084 17.9813 25.3859 17.9472 25.3608 17.9131C25.3396 17.8842 25.3198 17.8566 25.2973 17.8291C25.2749 17.8015 25.2524 17.7753 25.2299 17.749C25.2035 17.7189 25.1771 17.69 25.1493 17.6611C25.1281 17.6388 25.1057 17.6178 25.0832 17.5969C25.0528 17.568 25.0211 17.5391 24.9894 17.5129C24.9656 17.4932 24.9418 17.4748 24.918 17.4565C24.8863 17.4315 24.8532 17.4066 24.8202 17.383C24.7924 17.3633 24.7633 17.3463 24.7342 17.3279C24.7038 17.3082 24.6734 17.2898 24.6417 17.2728C24.6074 17.2531 24.5717 17.236 24.5347 17.2177C24.5069 17.2046 24.4805 17.1914 24.4527 17.1783C24.4117 17.1599 24.3707 17.1442 24.3285 17.1285C24.3033 17.1193 24.2782 17.1101 24.2531 17.1009C24.2095 17.0865 24.1659 17.0747 24.1223 17.0629C24.0958 17.0563 24.0694 17.0484 24.0429 17.0432C24.0006 17.034 23.9583 17.0261 23.916 17.0182C23.8843 17.013 23.8526 17.0077 23.8209 17.0038C23.7825 16.9986 23.7455 16.9959 23.7072 16.9933C23.6689 16.9907 23.6305 16.9881 23.5922 16.9881C23.575 16.9881 23.5578 16.9854 23.5393 16.9854C23.5208 16.9854 23.505 16.9881 23.4878 16.9881C23.4481 16.9881 23.4072 16.9907 23.3675 16.9946C23.3318 16.9973 23.2974 16.9999 23.2631 17.0051C23.2261 17.0091 23.1904 17.0156 23.1534 17.0222C23.115 17.0287 23.0767 17.0353 23.0397 17.0445C23.008 17.051 22.9776 17.0602 22.9458 17.0681C22.9035 17.0799 22.8626 17.0917 22.8216 17.1061C22.7952 17.1153 22.77 17.1245 22.7436 17.135C22.6987 17.1521 22.6537 17.1704 22.6101 17.1901C22.5876 17.2006 22.5665 17.2111 22.5453 17.2216C22.4991 17.2439 22.4541 17.2688 22.4092 17.2938C22.3986 17.3003 22.388 17.3043 22.3775 17.3108C22.3669 17.3174 22.3576 17.3253 22.3471 17.3318C22.3061 17.3581 22.2651 17.3856 22.2255 17.4132C22.203 17.4302 22.1792 17.446 22.1581 17.463C22.125 17.4893 22.092 17.5168 22.0602 17.5444C22.0351 17.5667 22.01 17.5877 21.9862 17.6113C21.9585 17.6375 21.9333 17.6638 21.9069 17.6913C21.8818 17.7176 21.858 17.7425 21.8342 17.77C21.8104 17.7976 21.7879 17.8265 21.7655 17.8553C21.7443 17.8829 21.7232 17.9104 21.7034 17.938C21.6809 17.9708 21.6597 18.0036 21.6386 18.0377C21.6227 18.0639 21.6055 18.0889 21.591 18.1151C21.5685 18.1532 21.5487 18.1938 21.5289 18.2332C21.517 18.2555 21.5064 18.2791 21.4958 18.3014C21.476 18.3447 21.4588 18.3893 21.4416 18.4352C21.4337 18.4562 21.4258 18.4785 21.4178 18.4995C20.4186 17.5601 19.069 16.9841 17.5846 16.9841C14.5009 16.9841 12 19.4665 12 22.5275C12 25.5884 14.5009 28.0708 17.5846 28.0708C19.069 28.0708 20.4186 27.4948 21.4192 26.5554C21.7179 27.4358 22.5546 28.0708 23.542 28.0708C24.4342 28.0708 25.2008 27.5526 25.5617 26.8047L25.7005 27.033C25.7851 27.1813 25.8869 27.3203 26.0058 27.4476C26.0098 27.4528 26.0151 27.4568 26.019 27.4607C26.064 27.5079 26.1102 27.5526 26.1591 27.5959C26.1724 27.6077 26.1856 27.6182 26.1988 27.6287C26.2398 27.6641 26.2821 27.6982 26.327 27.731C26.3482 27.7454 26.3693 27.7599 26.3905 27.773C26.4222 27.7953 26.4539 27.8176 26.487 27.8386C26.4949 27.8438 26.5028 27.8465 26.5107 27.8517C26.5319 27.8635 26.5544 27.874 26.5755 27.8858C26.6205 27.9094 26.6641 27.9344 26.7103 27.9553C26.7183 27.9593 26.7262 27.9619 26.7341 27.9658C27.0289 28.097 27.3408 28.16 27.6501 28.1587C27.9594 28.1587 28.2714 28.097 28.5662 27.9658C28.5741 27.9619 28.582 27.9593 28.5899 27.9553C28.6349 27.9344 28.6798 27.9107 28.7248 27.8858C28.7459 27.874 28.7684 27.8635 28.7895 27.8517C28.7975 27.8465 28.8054 27.8438 28.8133 27.8386C28.8477 27.8189 28.8781 27.7953 28.9098 27.773C28.931 27.7585 28.9521 27.7454 28.9733 27.7297C29.0182 27.6969 29.0592 27.6628 29.1015 27.6273C29.1147 27.6168 29.1279 27.6063 29.1411 27.5945C29.19 27.5512 29.2363 27.5053 29.2812 27.4594C29.2852 27.4542 29.2905 27.4502 29.2945 27.445C29.4134 27.3177 29.5165 27.1786 29.5998 27.0304L29.7241 26.827C30.0902 27.5617 30.8502 28.0682 31.7319 28.0682C32.9691 28.0682 33.9736 27.0724 33.9736 25.843V19.5505C34.1085 18.6871 33.7212 17.7884 32.9215 17.3069H32.9241ZM17.278 23.6099C16.6766 23.6099 16.1875 23.1244 16.1875 22.5275C16.1875 21.9305 16.6766 21.445 17.278 21.445C17.8794 21.445 18.3685 21.9305 18.3685 22.5275C18.3685 23.1244 17.8794 23.6099 17.278 23.6099Z" fill="white"/>
    </svg>
  </div>
  `,
  param: {
    hideIconOnBalloonOpen: false,
    // iconShape: {
    //   type: 'Rectangle',
    //   coordinates: [[0, 0], [48, 48]],
    // },
  },
};

const mapParam = {

};

const initMapContact = function () {
  if (domElem) {
    const map = new Map(domElem);

    ymaps.ready(() => { // eslint-disable-line

      map.createMap(mapOptions, mapParam);

      map.createPointTemplate(
          PointLayoutOptions.tmpl,
          PointLayoutOptions.name
      );

      points.forEach((point) => {
        const placemark = map.createPoint(point, {}, {}, map[PointLayoutOptions.name]);
        map.addPointToMap(placemark);
      });

      btnsContact.forEach((btn) => {
        const coords = btn.getAttribute('data-coords').split(',');
        const id = btn.getAttribute('data-contact');
        btn.addEventListener('click', () => {
          if (coords) {
            map.map.setCenter(coords);
          }
          if (id) {
            toggleContacts(id);
          }
        });
      });

      const btnMap = document.querySelector('.js-btn-map');
      const modal = btnMap.closest('#modal-map-contact');

      btnMap.addEventListener('click', () => {
        modal.classList.toggle('fullscreen-map');
      });
    });
  }

};

export default initMapContact;
